import React, { useMemo } from 'react'
import { url as gravatar } from 'gravatar'
import { Image } from 'semantic-ui-react'
import defaultAvatarUrl from 'assets/crm_avatar_missing.png'

export default function ContactAvatar({
  children,
  className,
  fallback: Fallback = false,
  email,
  onClick,
  size = 64,
  src,
}) {
  const style = useMemo(() => ({ height: size, width: size }), [size])
  if (Fallback && !src) return <Fallback />
  const imageUrl =
    src ||
    gravatar(email, {
      default: `${defaultAvatarUrl}`,
      size: size * 2,
    })
  return (
    <div className="ContactAvatar">
      <Image
        avatar
        className={className}
        onClick={onClick}
        src={imageUrl}
        style={style}
      />
      {children}
    </div>
  )
}
